import type { Asset } from '@/types/asset';
import { EmptyState } from './EmptyState';
import { IncomeExpenseChart } from './IncomeExpenseChart';
import { RecentTransactionsTable } from './RecentTransactionsTable';
import { RentalKpiDashboard } from './RentalKpiDashboard';
// import AssetDocuments from "./AssetDocuments"; // No longer needed here

interface AssetDetailsOverviewProps {
  assetId: string;
  asset?: {
    id?: number;
    assetId?: number;
    netYield: number;
    cashFlow: number;
    occupancy: number;
    investedAmount?: number;
    marketRent?: number;
    marketValue?: number;
    assetType?: string;
    transactions: {
      id: string;
      date: string;
      description: string;
      amount: number;
      status?: string;
      payee?: string;
    }[];
    performanceData: {
      month: string;
      income: number;
      expense: number;
    }[];
  };
  assetData?: Asset | null; // Add asset data prop
  onViewMoreTransactions?: () => void;
  onAddTransaction?: () => void;
  onEditAsset?: () => void; // Add edit asset handler
}

export default function AssetDetailsOverview({
  assetId,
  asset,
  assetData, // Add asset data parameter
  onViewMoreTransactions,
  onAddTransaction,
  onEditAsset, // Add edit asset parameter
}: AssetDetailsOverviewProps) {
  // Check if we have any financial data to show
  const hasTransactions = asset?.transactions && asset.transactions.length > 0;
  const hasPerformanceData =
    asset?.performanceData && asset.performanceData.length > 0;
  const hasFinancialData = hasTransactions || hasPerformanceData;

  // If no financial data, show empty state
  if (!hasFinancialData) {
    return (
      <div className="space-y-8">
        <RentalKpiDashboard assetId={assetId} />
        <EmptyState
          onAddTransaction={onAddTransaction}
          onViewTransactions={onViewMoreTransactions}
        />
      </div>
    );
  }

  return (
    <div className="space-y-8">
      <RentalKpiDashboard assetId={assetId} />
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <RecentTransactionsTable
          transactions={asset?.transactions || []}
          onViewMore={onViewMoreTransactions}
          onAddTransaction={onAddTransaction}
        />
        <div>
          <h3 className="font-semibold mb-2">Performance Chart</h3>
          <IncomeExpenseChart data={asset?.performanceData || []} />
        </div>
      </div>
      {/* AssetDocuments removed from overview tab */}
    </div>
  );
}
